import { useTranslation } from 'react-i18next';
import { ExternalLink, BookOpen } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { ANALYTICS_EVENTS, track } from '@/lib/analytics';

/**
 * Global Resources page. Mirrors v1's `resources.tsx` (Knowledge Base link).
 *
 * The Knowledge Base lives at clinical-support.rxfood.com under a locale
 * folder — `en` for English, `fr-ca` for French. We pick the URL off the
 * active i18n language so French users land on the French portal.
 *
 * v1 also embedded a Zoho support-ticket iframe here, but per the V2
 * migration discussion we're keeping this page minimal — the Knowledge
 * Base portal itself has a "submit a ticket" affordance.
 */
export default function GlobalResources() {
  const { t, i18n } = useTranslation();
  const lang = i18n.language?.startsWith('fr') ? 'fr-ca' : 'en';
  const knowledgeBaseUrl = `https://clinical-support.rxfood.com/portal/${lang}/home`;

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t('Resources')}</CardTitle>
      </CardHeader>
      <CardContent className="space-y-3">
        <p className="text-sm text-muted-foreground">
          {t('Help articles, walkthroughs, and how to contact RxFood support.')}
        </p>
        <a
          href={knowledgeBaseUrl}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => track(ANALYTICS_EVENTS.HELP_CLICKED, { destination: 'knowledge_base' })}
          className="inline-flex items-center gap-2 rounded-md border border-primary/30 bg-primary/5 px-3 py-2 text-sm font-medium text-primary transition-colors hover:bg-primary/10"
        >
          <BookOpen className="h-4 w-4" />
          {t('Knowledge Base')}
          <ExternalLink className="h-3.5 w-3.5 opacity-70" />
        </a>
      </CardContent>
    </Card>
  );
}
